import React from "react";
import { Container } from "@material-ui/core";
import BackButton from "./BackButton/BackButton";

interface IProps {
  showBack?: boolean;
  backhandler?: () => void;
  title?: string;
}

export default function PageHero(props: IProps) {
  function backHandler() {
    if (props.backhandler) props.backhandler();
  }
  return (
    <div className="page-hero">
      <Container maxWidth="xl">
        {props.showBack ? <BackButton backHandler={backHandler} /> : null}
        <h2 className="title">{props.title}</h2>
      </Container>
    </div>
  );
}
